import api from './api';

/**
 * Get Google OAuth authorization URL
 * @returns {Promise<string>} Authorization URL
 */
export const getAuthUrl = async () => {
  try {
    const response = await api.get('/google/auth');
    return response.data.authUrl;
  } catch (error) {
    console.error('Error getting Google auth URL:', error);
    throw error;
  }
};

/**
 * Disconnect Google Calendar
 * @returns {Promise<object>} Success response
 */
export const disconnectCalendar = async () => {
  try {
    const response = await api.post('/google/disconnect');
    return response.data;
  } catch (error) {
    console.error('Error disconnecting Google Calendar:', error);
    throw error;
  }
};

/**
 * Get Google Calendar connection status
 * @returns {Promise<object>} Connection status
 */
export const getConnectionStatus = async () => {
  try {
    const response = await api.get('/google/status');
    return response.data;
  } catch (error) {
    console.error('Error getting connection status:', error);
    throw error;
  }
};

/**
 * Initiate Google Calendar connection flow
 * Opens popup window for OAuth flow
 * @returns {Promise<boolean>} Success status
 */
export const connectGoogleCalendar = async () => {
  try {
    // Get OAuth URL
    const authUrl = await getAuthUrl();

    // Open popup window for OAuth
    const width = 600;
    const height = 700;
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    const popup = window.open(
      authUrl,
      'Google Calendar Authorization',
      `width=${width},height=${height},left=${left},top=${top},toolbar=no,menubar=no`
    );

    // Poll for popup close or URL change
    return new Promise((resolve, reject) => {
      const pollTimer = setInterval(() => {
        if (!popup || popup.closed) {
          clearInterval(pollTimer);
          // Check if connection was successful by calling status endpoint
          getConnectionStatus()
            .then(status => {
              if (status.connected) {
                resolve(true);
              } else {
                reject(new Error('Connection was cancelled or failed'));
              }
            })
            .catch(err => {
              reject(err);
            });
        }
      }, 500);

      // Timeout after 5 minutes
      setTimeout(() => {
        clearInterval(pollTimer);
        if (popup && !popup.closed) {
          popup.close();
        }
        reject(new Error('Connection timeout'));
      }, 5 * 60 * 1000);
    });
  } catch (error) {
    console.error('Error connecting Google Calendar:', error);
    throw error;
  }
};

export default {
  getAuthUrl,
  disconnectCalendar,
  getConnectionStatus,
  connectGoogleCalendar
};
